import Home from '../pages/home.vue';
import Request from '../pages/request.vue';
import BankruptcyFile from '../pages/bankruptcy-file.vue';
import SubRequest from '../pages/sub-requests.vue';
import SubRequestSelector from '../pages/sub-request-selector.vue';
import SubRequestFile from '../pages/sub-request-file.vue';
import ReplyMemo from '../pages/reply-memo.vue';
import SubRequestTypesList from '../components/sub-requests/Categorized/sub-request-types-category.vue';
import ElitigationSessions from '../pages/elitigation-sessions.vue';

import ar from '@/local/ar.js';
export default [
  {
    path: '/bankruptcy/:requestObjectKey/Categorized',
    name: 'SubRequestTypesList',
    component: SubRequestTypesList,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
    props: true,
  },
  {
    path: '/bankruptcy',
    name: 'bankruptcy',
    component: Home,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        text: ar.breadcrumbs.bankruptcy,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/bankruptcy-file/:objectKey',
    name: 'bankruptcy-file',
    component: BankruptcyFile,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/bankruptcy-file/:requestType',
    name: 'create-sub-request',
    component: SubRequest,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/bankruptcy-file/sub-request/:requestType/:subRequestObjectKey',
    name: 'new-sub-request',
    component: SubRequest,
    meta: {
      isChild: true,
      isNew: true,
      isInternal: true,
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/bankruptcy-file/sub-request/:requestType/:subRequestObjectKey/external',
    name: 'new-sub-request',
    component: SubRequest,
    meta: {
      isChild: true,
      isNew: true,
      isInternal: false,
      isExternalVerdictObjectionRequest: true,
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/bankruptcy-file/view-sub-request/:requestType/:subRequestObjectKey',
    name: 'view-sub-request',
    component: SubRequest,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/bankruptcy-file/sub-request/view-sub-request/:requestType/:subRequestObjectKey',
    name: 'view-child-sub-request',
    component: SubRequest,
    meta: {
      isChild: true,
      isInternal: true,
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/sub-request',
    name: 'sub-request-selector',
    component: SubRequestSelector,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/bankruptcy-file/:requestType/:subRequestObjectKey',
    name: 'view-edit-sub-request',
    component: SubRequest,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/request',
    name: 'bankruptcy-request',
    component: Request,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequest,
        isDynamic: false,
      },
    },
    children: [
      {
        path: ':step',
        name: 'edit-requests-with-step',
        component: Request,
      },
      {
        path: ':step/:objectKey',
        name: 'edit-requests-with-step-and-objectKey',
        component: Request,
      },
    ],
  },
  {
    path: '/bankruptcy/sub-request',
    name: 'sub-request',
    component: SubRequest,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcySubRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/sub-request/:requestType/:subRequestObjectKey',
    name: 'view-sub-request-file',
    component: SubRequestFile,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.bankruptcyRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/reply-memo',
    name: 'view-reply-memo',
    component: ReplyMemo,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.replyMemo,
        isDynamic: false,
      },
    },
  },
  {
    path: '/bankruptcy/:mainRequestObjectKey/reply-memo/:replyMemoObjectKey',
    name: 'create-reply-memo',
    component: ReplyMemo,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.replyMemo,
        isDynamic: false,
      },
    },
  },
  {    
    path: '/bankruptcy/bankruptcy-file/:requestObjectKey/elitigation-sessions/:sessionObjectKey',
    name: 'elitigation-sessions',
    component: ElitigationSessions,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.myRequests,
      },
    },
  },
  {    
    path: '/bankruptcy/bankruptcy-file/:requestObjectKey/sub-requests/:subRequestObjectKey/elitigation-sessions/:sessionObjectKey',
    name: 'sub-request-elitigation-sessions',
    component: ElitigationSessions,
    meta: {
      breadcrumbs: {
        hide: false,
        onBase: true,
        isBankruptcy: true,
        text: ar.breadcrumbs.myRequests,
      },
    },
  },
];
